module.exports = __webpack_public_path__ + "img/Brick-Texture.86fb4fe8.jpg";